// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"NoResults_Wrap__qTHkG","Text":"NoResults_Text__26l0v","Button":"NoResults_Button__3iG29"};